@if (location(); as locationVal) {
  <a
    target="__blank"
    [href]="
      locationVal.url ||
      'https://www.google.com.tw/maps/search/' + locationVal.name
    "
    class="text-href underline"
  >
    <ng-content>
      <span>
        {{ locationVal.name }}
      </span>
    </ng-content>
  </a>
}
